/**
 * en-GB messages added by Phase 4 task S54 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s54EnGB = {
    'evacuation.error.kiosk_drill_off': 'This site does not allow a drill to be started from a kiosk.',
};
//# sourceMappingURL=s54.js.map